<app-header (showSearch)="showSearchChange($event)"></app-header>
<main *ngIf="!isShowSearch">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
